/**
 * Rows to CSV text the importer (and a spreadsheet) read back unchanged:
 * RFC 4180 quoting, newlines kept as newlines, a byte order mark so Excel reads UTF-8.
 */
export function csvCell(value) {
  const s = value == null ? '' : String(value);
  return /[",\n\r]/.test(s) || /^\s|\s$/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(header, rows) {
  const lines = [header.map(csvCell).join(',')];
  for (const r of rows) lines.push(header.map((h) => csvCell(r[h])).join(','));
  return `﻿${lines.join('\r\n')}\r\n`;
}
